module.exports = __webpack_public_path__ + "img/direction_vertiical.f0ca2603.png";